module.exports = __webpack_public_path__ + "static/giant_strider-2002b5d6f4e4c79146ea30d308d3f7b6.jpeg";